// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.variant-row-actions {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

/* Delete is a low-emphasis text link next to the Edit button, not a second
   equal-weight button. */
.variant-row-actions__delete {
    padding: 0;
    border: 0;
    background: none;
    color: var(--color-error, #c0392b);
    font: inherit;
    text-decoration: underline;
    cursor: pointer;
}

.variant-row-actions__delete:hover {
    text-decoration: none;
}

/* Per-variant shipping override inside the edit subpane. */
.variant-shipping-override {
    border: 1px solid var(--color-border, #ddd);
    border-radius: 4px;
    padding: 0.75rem 1rem 1rem;
    margin: 0.5rem 0 1rem;
}

.variant-shipping-override > legend {
    font-weight: bold;
    padding: 0 0.4rem;
}

.variant-shipping-override .variant-shipping-methods {
    border: 1px solid var(--color-border, #ddd);
    padding: 0.5rem 0.75rem;
    margin: 0.5rem 0;
}

.variant-shipping-override .variant-shipping-methods > legend {
    font-weight: bold;
    color: var(--color-text-muted, #666);
    font-size: 0.9em;
}

.variant-shipping-override input:disabled,
.variant-shipping-override .checkbox input:disabled + span {
    opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Product/ProductWizardStock.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;yBACyB;AACzB;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,kCAAkC;IAClC,aAAa;IACb,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA,2DAA2D;AAC3D;IACI,2CAA2C;IAC3C,kBAAkB;IAClB,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;AAChB","sourcesContent":[".variant-row-actions {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n/* Delete is a low-emphasis text link next to the Edit button, not a second\n   equal-weight button. */\n.variant-row-actions__delete {\n    padding: 0;\n    border: 0;\n    background: none;\n    color: var(--color-error, #c0392b);\n    font: inherit;\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.variant-row-actions__delete:hover {\n    text-decoration: none;\n}\n\n/* Per-variant shipping override inside the edit subpane. */\n.variant-shipping-override {\n    border: 1px solid var(--color-border, #ddd);\n    border-radius: 4px;\n    padding: 0.75rem 1rem 1rem;\n    margin: 0.5rem 0 1rem;\n}\n\n.variant-shipping-override > legend {\n    font-weight: bold;\n    padding: 0 0.4rem;\n}\n\n.variant-shipping-override .variant-shipping-methods {\n    border: 1px solid var(--color-border, #ddd);\n    padding: 0.5rem 0.75rem;\n    margin: 0.5rem 0;\n}\n\n.variant-shipping-override .variant-shipping-methods > legend {\n    font-weight: bold;\n    color: var(--color-text-muted, #666);\n    font-size: 0.9em;\n}\n\n.variant-shipping-override input:disabled,\n.variant-shipping-override .checkbox input:disabled + span {\n    opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
